<template>
  <div>
    <!-- <b-container> -->
    <b-navbar
      toggleable="lg"
      type="light"
      variant="light"
      fixed="top"
      class="border-top"
    >
      <b-navbar-brand href="/">
        <img :src="images.logo" alt="ICMS" width="200" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto" right>
          <b-nav-item v-for="menu in menus" :key="menu.text" :to="menu.link">
            {{ menu.name }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!-- </b-container> -->
  </div>
</template>

<script>
// import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      images: {
        logo: require("@/assets/logo.png")
      },
      appTitle: "Integrated Cash Management Services Ltd.",
      menus: [
        { name: "Home", link: "/" },
        { name: "About Us", link: "/about-us" },
        { name: "Our Services", link: "/our-services" },
        { name: "Media", link: "/news" },
        { name: "Contact Us", link: "/contact-us" }
        // { name: "Webinar", link: "/webinar" }
      ]
    };
  },
  methods: {
    showConsignmentModal() {
      this.$refs["consignment-modal"].show();
    }
  }
};
</script>
<style scoped>
.border-top {
  border-top: 2px solid #af0000 !important;
}
.navbar {
  padding-top: 0;
  padding-bottom: 0;
  -webkit-box-shadow: 0px 0 10px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0 10px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0 10px rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .nav-link {
  padding: 20px 15px;
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover {
  padding: 20px 15px;
  background: #af0000;
  color: #ffffff;
}

.router-link-exact-active {
  background: #af0000 !important;
  color: #ffffff !important;
}

.tracker .btnn {
  font-size: 1.1em;
  padding: 10px 20px;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
}

.tracker .btnn {
  background: #880e4f;
  border-radius: 15px;
  box-shadow: -3px -3px 8px #f5c0dc, 3px 3px 8px #f1c2db;
}

.search-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.4);
  max-width: 550px;
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
}

.search-wrapper .input {
  width: 85%;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 24px;
}

.searchbtn {
  background: #af0000;
  width: 10%;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
}

.searchbtn .fas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  color: #ffffff;
}

.root {
  padding: 3rem 1.5rem;
  border-radius: 5px;
  box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.3);
}
.cnt {
  font-weight: 600;
}
.order-track {
  margin-top: 2rem;
  padding: 0 1rem;
  border-top: 1px dashed #2c3e50;
  padding-top: 2.5rem;
  display: flex;
  flex-direction: column;
}
.order-track-step {
  display: flex;
  height: 7rem;
}
.order-track-step:last-child {
  overflow: hidden;
  height: 4rem;
}
.order-track-step:last-child .order-track-status span:last-of-type {
  display: none;
}
.order-track-status {
  margin-right: 1.5rem;
  position: relative;
}
.order-track-status-dott {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background: #ccc;
}
.order-track-status-linet {
  display: block;
  margin: 0 auto;
  width: 2px;
  height: 7rem;
  background: #ccc;
}
.order-track-status-dot {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background: #af0000;
}
.order-track-status-line {
  display: block;
  margin: 0 auto;
  width: 2px;
  height: 7rem;
  background: #af0000;
}
.order-track-text-stat {
  font-size: 1.3rem;
  font-weight: 500;
  margin-bottom: 3px;
}
.order-track-text-sub {
  font-size: 1rem;
  font-weight: 300;
}
.order-track {
  transition: all 0.3s height 0.3s;
  transform-origin: top center;
}
</style>
